import * as React from "react";
import { useCallback } from "react";
import styled from "styled-components";
import Immutable from "immutable";
import FieldSelect from "data-lake/components/FieldSelect";
import StickyBottomActions from "views/components/widgets/StickyBottomActions";
import SaveOrCancelButtons from "views/components/widgets/SaveOrCancelButtons";
import DescriptionBox from "views/components/aggregationbuilder/DescriptionBox";
import FieldsConfiguration from "views/components/widgets/FieldsConfiguration";
import { Alert, Button } from "components/bootstrap";
import { WAHREHOUSE_PREVIEW_FORM_ID } from "data-lake/preview/storage-types/internal/SearchBar";
import { Icon } from "components/common";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import hasCustomFields from "data-lake/preview/utils/hasCustomFields";
import useReexecuteNeedWarning from "data-lake/preview/hooks/useReexecuteNeedWarning";
import usePreviewLayout from "data-lake/preview/hooks/usePreviewLayout";
import useFieldTypes from "data-lake/hooks/useFieldTypes";
import useSelectedDataLake from "data-lake/hooks/useSelectedDataLake";
import useReexecuteSearch from "data-lake/preview/hooks/useReexecuteSearch";
import DataLakeFieldsContext from "./contexts/DataLakeFieldsContext";
const Container = styled.div`
  height: 100%;
  width: 100%;
  padding-bottom: 15px;
  display: flex;
`;
const Col = styled.div`
  height: 100%;
`;
const ControlsCol = styled(Col)`
  min-width: 315px;
  max-width: 500px;
  flex: 1.2;
  padding-right: 5px;
  margin-right: 10px;
`;
const LogViewCol = styled(Col)`
  flex: 3;
  overflow-y: hidden;
`;
const LogViewEditFieldSelect = ({ ...props }) => {
  const { widgetEdit } = usePreviewLayout();
  return /* @__PURE__ */ React.createElement(FieldSelect, { ...props, allowCreate: widgetEdit == null ? void 0 : widgetEdit.fieldsCreationAllowed });
};
const DataLakeLogViewEdit = ({
  children = void 0,
  config,
  onChange,
  onCancel,
  isFetching,
  configBeforeEdit
}) => {
  const sendTelemetry = useSendTelemetry();
  const { data: defaultFields } = useFieldTypes();
  const reexecuteNeedWarning = useReexecuteNeedWarning(config, configBeforeEdit, defaultFields);
  const { widgetEdit } = usePreviewLayout();
  const { selectedDataLake } = useSelectedDataLake();
  const reexecuteSearch = useReexecuteSearch();
  const onChangeFields = useCallback(
    (newFields) => {
      const newFieldsSet = Immutable.OrderedSet(newFields);
      sendTelemetry(TELEMETRY_EVENT_TYPE.DATALAKE.PREVIEW[selectedDataLake.type].WIDGET_FIELDS_UPDATE, {
        app_pathname: "/data-storage/preview",
        app_section: "log-view-widget",
        event_details: {
          fields: newFields,
          hasCustomFields: hasCustomFields(newFieldsSet, defaultFields),
          data_lake_storage_type: selectedDataLake.storageType
        }
      });
      onChange(config.toBuilder().fields(Immutable.OrderedSet(newFields)).build());
    },
    [config, defaultFields, onChange, selectedDataLake.storageType, selectedDataLake.type, sendTelemetry]
  );
  return /* @__PURE__ */ React.createElement(DataLakeFieldsContext.Provider, { value: Immutable.List(config.fields) }, /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(ControlsCol, null, /* @__PURE__ */ React.createElement(StickyBottomActions, { actions: /* @__PURE__ */ React.createElement(SaveOrCancelButtons, { onCancel }), alignActionsAtBottom: true }, /* @__PURE__ */ React.createElement(DescriptionBox, { description: "Field Selection and Order" }, (widgetEdit == null ? void 0 : widgetEdit.showFieldSelect) && /* @__PURE__ */ React.createElement(
    FieldsConfiguration,
    {
      onChange: onChangeFields,
      fieldSelect: LogViewEditFieldSelect,
      createSelectPlaceholder: (widgetEdit == null ? void 0 : widgetEdit.fieldsCreationAllowed) ? "Select or type in any field name" : "Select field name",
      selectSize: "normal",
      selectedFields: config.fields.toArray()
    }
  ), widgetEdit == null ? void 0 : widgetEdit.fieldSelectInfo), reexecuteNeedWarning && /* @__PURE__ */ React.createElement(Alert, { bsStyle: "warning" }, /* @__PURE__ */ React.createElement("p", null, reexecuteNeedWarning), /* @__PURE__ */ React.createElement(
    Button,
    {
      type: "submit",
      bsSize: "xsmall",
      bsStyle: "primary",
      disabled: isFetching,
      onClick: reexecuteSearch,
      form: WAHREHOUSE_PREVIEW_FORM_ID
    },
    /* @__PURE__ */ React.createElement(Icon, { name: "search" }),
    "Re-execute search"
  )), widgetEdit == null ? void 0 : widgetEdit.formInfo)), /* @__PURE__ */ React.createElement(LogViewCol, null, children)));
};
export default DataLakeLogViewEdit;
